import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Icon from '../../Icon';
import styles from './TreeFilter.module.less';

const TreeFilter = ({
  displayName,
  urlName,
  count,
  href,
  selected,
  expand,
  onClick,
  group,
  contentRequestInProcess,
}) => {
  const disabled = count === 0;
  const handleClick = e => {
    if (e.type !== 'click' && e.key !== 'Enter') {
      return;
    }

    if (!disabled && typeof onClick === 'function') {
      onClick(e, href);
    }
  };

  const content = (
    <a href={href} className={clsx(styles.filterHref)}>
      <span className={clsx(styles.icon)}>
        {selected && (
          <span
            className={clsx(styles.selectedIcon)}
            data-cy="filter-selected-icon"
          ></span>
        )}
      </span>
      {selected ? (
        <span className={clsx(styles.selectedDisplayName)}>{displayName}</span>
      ) : (
        <span className={clsx(styles.displayName)}>{displayName}</span>
      )}
      {selected && (
        <Icon
          name="cancel-circled"
          className={clsx(styles.removeIcon)}
          dataCy="icon-cancel-circle"
        />
      )}
    </a>
  );

  const classes = clsx(styles.link, {
    [styles.disabled]: disabled,
    [styles.bottomLevel]: true,
    [styles.selected]: selected,
    [styles.hidden]: disabled && (group === 'contentType' || group === 'grade'),
    [styles.unclickable]: contentRequestInProcess,
    [styles.collapsed]: !expand && !selected,
  });

  let filterLink;
  filterLink = (
    <div
      className={classes}
      onClick={handleClick}
      onKeyDown={handleClick}
      role="link"
      tabIndex={0}
    >
      {content}
    </div>
  );

  return (
    <li key={urlName} className={styles.filter}>
      {filterLink}
    </li>
  );
};

TreeFilter.displayName = 'TreeFilter';
TreeFilter.propTypes = {
  displayName: PropTypes.string,
  urlName: PropTypes.string,
  count: PropTypes.number,
  href: PropTypes.string,
  selected: PropTypes.bool,
  expand: PropTypes.bool,
  onClick: PropTypes.func,
  group: PropTypes.string,
  contentRequestInProcess: PropTypes.bool.isRequired,
};

export default TreeFilter;
